import { SignJWT, jwtVerify, errors } from "jose";
import { GcoopSession } from "../session-helper";
import { message } from "antd";

const alg = "HS256";
const JWT_SECRET = `gcoop-key-secret`;
const jwtKey = new TextEncoder().encode(JWT_SECRET);

export const gerarJWT = async (sessao?: Record<string, any>) => {
  const token = await new SignJWT(sessao)
    .setProtectedHeader({ alg })
    .setIssuedAt()
    .setExpirationTime("5 minutes")
    .sign(jwtKey);

  return token;
};

export const decifrarJWT = async (token: string) => {
  try {
    const { payload } = await jwtVerify<GcoopSession>(token, jwtKey, {
      algorithms: [alg],
    });
    return payload;
  } catch (error) {
    if (error instanceof errors.JWTExpired) {
      message.warning("Login expirado");
    }

    return null;
  }
};
